import React from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";

interface UseCaseCardProps {
  agent_id: string;
  title: string;
  description?: string;
  image?: string;
}

const UseCaseCard = ({
  agent_id,
  title,
  description,
  image,
}: UseCaseCardProps) => {
  return (
    <Link to={`/agent/${agent_id}`}>
      <div className="rounded-2xl border border-gray-200 overflow-hidden transition-all duration-300 cursor-pointer pt-6 px-6 h-auto flex flex-col group">
        <div className="mb-4 flex items-center gap-3">
          <div className="w-8 h-8 bg-black rounded-full flex items-center justify-center relative flex-shrink-0">
            <div className="w-3 h-3 bg-white transition-opacity duration-300 group-hover:opacity-0"></div>
            <Play className="w-4 h-4 text-white fill-white transition-opacity duration-300 opacity-0 group-hover:opacity-100 absolute" />
          </div>
          <h3 className="font-serif-kr text-[#262626] text-base xl:text-xl font-normal leading-[120%]">
            {title}
          </h3>
        </div>

        {image && (
          <div className="w-full relative h-[200px] mt-auto px-0 md:px-6">
            <img
              src={image}
              alt={title}
              className="w-full h-full object-fill rounded-t-lg "
              loading="lazy"
            />
          </div>
        )}
      </div>
    </Link>
  );
};

export default UseCaseCard;
